import { Repair } from '../../../../History/interfaces';
import { AlertMessage } from '../../../../../../shared/AlertMessage';

interface Props {
  repair: Repair | null;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteModal = ({ repair, onClose, onDelete }: Props) => {
  return (
    <AlertMessage.Root
      isOpen
      onClose={onClose}
      title="Excluir OS?"
      footer={
        <AlertMessage.Footer>
          <>
            <AlertMessage.ConfirmButton onClick={onClose}>
              Revisar
            </AlertMessage.ConfirmButton>
            <AlertMessage.CancelButton
              onClick={() => {
                onDelete();
                onClose();
              }}
            >
              Excluir
            </AlertMessage.CancelButton>
          </>
        </AlertMessage.Footer>
      }
    >
      <AlertMessage.Body>
        <p>
          A OS: <b>{repair?.external_id || repair?.OS || ''}</b> será excluída
        </p>
      </AlertMessage.Body>
    </AlertMessage.Root>
  );
};
